<template>
  <div
    ref="pageScroller"
    class="store-home-page"
    @scroll.passive="handlePageScroll"
  >
    <header class="store-hero">
      <section class="store-profile">
        <img
          class="store-logo"
          :src="shopImage"
          alt=""
          @error="logoError = true"
        >
        <div class="store-main">
          <div class="store-title">
            <span>{{ shop.name || '--' }}</span>
            <em>{{ $t('shopCenter.verified') }}</em>
          </div>
          <div class="credit-row">
            <span>{{ shop.credit || 0 }}</span>
            <van-icon
              v-for="index in 5"
              :key="index"
              name="star"
              :class="{ active: index <= starCount }"
            />
          </div>
        </div>
        <button
          type="button"
          class="favorite-btn"
          :class="{ active: isFav }"
          :disabled="favLoading || !shop.id"
          @click="toggleFavorite"
        >
          <van-icon :name="isFav ? 'star' : 'star-o'" />
          <span>{{ $t('user.favorite') }}</span>
        </button>
      </section>
    </header>

    <main class="store-content">
      <section class="goods-panel">
        <h1>
          <van-icon name="shop-o" />
          <span>{{ shop?.class_title }}</span>
        </h1>
        <van-list
          ref="goodsList"
          v-model="listLoading"
          :finished="finished"
          :offset="120"
          :loading-text="$t('hotelList.loading')"
          @load="loadGoods"
        >
          <div
            v-if="goods.length"
            class="goods-grid"
          >
            <article
              v-for="item in goods"
              :key="item.id"
              class="goods-card"
              @click="goDetail(item)"
            >
              <div class="goods-image">
                <img
                  :src="goodsImage(item)"
                  alt=""
                  @error="onGoodsImageError"
                >
              </div>
              <div class="goods-title">
                {{ item.title || '--' }}
              </div>
              <div class="goods-meta">
                <span class="goods-price">${{ formatPrice(item.price) }}</span>
                <span class="goods-sold">{{ $t('hotelList.sold') }} {{ formatSold(item.sold) }}</span>
              </div>
            </article>
          </div>
          <div
            v-else-if="!requesting"
            class="empty-state"
          >
            {{ $t('hotelList.empty') }}
          </div>
        </van-list>
      </section>
    </main>
    <!-- 
      <div
      class="kefu"
      @click.stop="kefuTo"
    >
      <div class="kefu_img">
        <van-icon name="service-o" />
      </div>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Dialog, Icon, List, Toast } from 'vant';

Vue.use(Icon).use(Dialog).use(List).use(Toast);

export default {
  name: 'Hotel',
  data() {
    return {
      app: {},
      shop: {},
      goods: [],
      loading: false,
      listLoading: false,
      requesting: false,
      finished: false,
      goodsReady: false,
      logoError: false,
      logoFallback: require('../images/shop2/thumbnail.png'),
      goodsFallback: require('../images/shop2/pro.png'),
      page: 1,
      limit: 20,
      publicSid: 0,
      isFav: false,
      favLoading: false,
    };
  },
  computed: {
    shopImage() {
      if (this.logoError) {
        return this.logoFallback;
      }
      return this.buildImageUrl(this.shop.img, this.logoFallback);
    },
    starCount() {
      var credit = Number(this.shop.credit || 0);
      if (!isFinite(credit) || credit <= 0) {
        return 0;
      }
      return Math.max(1, Math.min(5, Math.ceil(credit / 20)));
    },
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('shoplist', true);
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data || {};
      });
      this.publicSid = Number(this.$route.query.sid || 0);
      if (this.publicSid > 0) {
        this.resetList();
        this.goodsReady = true;
        this.loadGoods();
        return;
      }
      Fetch('/user/shop_info', {}, null, true).then((r) => {
        var data = r.data || {};
        this.shop = data.shop || {};
        this.logoError = false;
        this.routeByStatus();
      });
    },
    routeByStatus() {
      if (!this.shop || !this.shop.id) {
        this.$router.replace('/aplyshop');
        return;
      }
      var stat = Number(this.shop.stat);
      if (stat !== 1) {
        Dialog.alert({
          title: this.$t('utils.prompt'),
          message: stat === 2 ? this.$t('shopCenter.frozenTip') : this.$t('shopCenter.pausedTip'),
          confirmButtonText: this.$t('utils.confirm'),
        }).then(() => {
          this.$router.replace(stat === 2 ? '/user' : '/shop');
        });
        return;
      }
      this.resetList();
      this.goodsReady = true;
      this.loadGoods();
      this.loadFavoriteStatus();
    },
    loadGoods() {
      if (!this.goodsReady || this.requesting || this.finished) {
        this.listLoading = false;
        return;
      }
      this.requesting = true;
      this.loading = true;
      this.listLoading = true;
      var isPublic = this.publicSid > 0;
      var url = isPublic ? '/index/shop_detail' : '/user/shop_goods';
      var params = {
        page: this.page,
        limit: this.limit,
      };
      if (isPublic) {
        params.sid = this.publicSid;
      }
      Fetch(url, params, null, isPublic && this.page === 1).then((r) => {
        var data = r.data || {};
        var list = Array.isArray(isPublic ? data.goods : data.list) ? (isPublic ? data.goods : data.list) : [];
        if (isPublic && this.page === 1) {
          this.shop = data.shop || {};
          this.logoError = false;
          this.loadFavoriteStatus();
        }
        this.goods = this.page === 1 ? list : this.goods.concat(list);
        this.finished = this.isFinished(data, list);
        this.page += 1;
      }).catch(() => {
        if (this.page === 1) {
          this.goods = [];
        }
        this.finished = true;
        if (isPublic && this.page === 1) {
          Toast(this.$t('hotelDetail.noShop'));
          this.$router.back();
        }
      }).finally(() => {
        this.requesting = false;
        this.loading = false;
        this.listLoading = false;
        this.checkList();
      });
    },
    isFinished(data, list) {
      if (data && Object.prototype.hasOwnProperty.call(data, 'total')) {
        var total = Number(data.total || 0);
        return this.goods.length >= total || list.length < this.limit;
      }
      return list.length < this.limit;
    },
    resetList() {
      this.page = 1;
      this.goods = [];
      this.finished = false;
      this.listLoading = false;
      this.requesting = false;
      this.loading = false;
    },
    handlePageScroll(event) {
      var target = event && event.target ? event.target : this.$refs.pageScroller;
      if (!target || this.requesting || this.finished) {
        return;
      }
      var distance = target.scrollHeight - target.scrollTop - target.clientHeight;
      if (distance <= 120) {
        this.loadGoods();
      }
    },
    checkList() {
      this.$nextTick(() => {
        if (this.$refs.goodsList && typeof this.$refs.goodsList.check === 'function') {
          this.$refs.goodsList.check();
        }
        this.handlePageScroll({
          target: this.$refs.pageScroller,
        });
      });
    },
    loadFavoriteStatus() {
      if (!this.shop || !this.shop.id) {
        this.isFav = false;
        return;
      }
      Fetch('/user/fav_status', {
        type: 'shop',
        id: this.shop.id,
      }).then((r) => {
        var data = r.data || {};
        this.isFav = Number(data.is_fav || 0) === 1;
      }).catch(() => {
        this.isFav = false;
      });
    },
    toggleFavorite() {
      if (!this.shop || !this.shop.id || this.favLoading) {
        return;
      }
      this.favLoading = true;
      Fetch('/user/fav_toggle', {
        type: 'shop',
        id: this.shop.id,
      }, null, true).then((r) => {
        var data = r.data || {};
        var next = Number(data.is_fav || 0) === 1;
        if (next !== this.isFav) {
          var fav = Number(this.shop.fav || 0);
          this.shop.fav = Math.max(0, fav + (next ? 1 : -1));
        }
        this.isFav = next;
        Toast(this.responseMessage(r));
      }).finally(() => {
        this.favLoading = false;
      });
    },
    responseMessage(response) {
      var info = response && response.info;
      var lang = this.$i18n.locale || 'en_us';
      if (info && typeof info === 'object') {
        return info[lang] || info.en_us || info.zh_cn || 'Success';
      }
      return info || 'Success';
    },
    goDetail(item) {
      var id = Number((item && (item.pid || item.id)) || 0);
      if (!id) {
        return;
      }
      this.$router.push({
        path: '/hotelit',
        query: {
          id: id,
        },
      });
    },
    buildImageUrl(path, fallback) {
      if (!path) {
        return fallback;
      }
      if (/^(https?:)?\/\//.test(path) || String(path).indexOf('data:') === 0) {
        return path;
      }
      if (this.app && this.app.domain) {
        return this.app.domain.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
      }
      return path;
    },
    goodsImage(item) {
      return this.buildImageUrl(item && item.img, this.goodsFallback);
    },
    onGoodsImageError(event) {
      if (event && event.target && event.target.src !== this.goodsFallback) {
        event.target.src = this.goodsFallback;
      }
    },
    formatPrice(value) {
      var number = Number(value);
      if (!isFinite(number)) {
        number = 0;
      }
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatSold(value) {
      var number = Number(value);
      if (!isFinite(number) || number < 0) {
        number = 0;
      }
      if (number === 0) {
        return '0';
      }
      var shortNumber = number / 1000;
      var fixed = shortNumber >= 10 ? shortNumber.toFixed(0) : shortNumber.toFixed(1);
      return fixed.replace(/\.0$/, '') + 'k+';
    },
    kefuTo() {
      if (this.app && this.app.kefu_link) {
        window.location.href = this.app.kefu_link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.store-home-page {
  height: 100vh;
  min-height: 100vh;
  overflow-y: auto;
  padding-bottom: 72px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  background: #eef7ff;
  color: #06152b;
}

.store-hero {
  height: 132px;
  padding: 18px 14px 0;
  background: linear-gradient(135deg, #ffd927 0%, #ffb31e 50%, #ff8618 100%);
}

.store-profile {
  display: flex;
  align-items: flex-start;
}

.store-logo {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  border-radius: 8px;
  object-fit: cover;
  background: #13204a;
}

.store-main {
  min-width: 0;
  flex: 1;
  padding: 8px 8px 0 12px;
}

.store-title {
  display: flex;
  align-items: center;
  min-width: 0;
}

.store-title span {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #06152b;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.store-title em {
  flex: 0 0 auto;
  margin-left: 7px;
  padding: 0 8px;
  border-radius: 4px;
  background: #050505;
  color: #fff;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
}

.credit-row {
  display: flex;
  align-items: center;
  margin-top: 3px;
  color: #06152b;
  font-size: 14px;
  line-height: 18px;
}

.credit-row span {
  margin-right: 3px;
}

.credit-row .van-icon {
  margin-right: 1px;
  color: rgba(255, 221, 60, .45);
  font-size: 14px;
}

.credit-row .active {
  color: #ffde27;
}

.favorite-btn {
  display: flex;
  align-items: center;
  height: 34px;
  margin-top: 27px;
  padding: 0 10px;
  border: 0;
  border-radius: 17px;
  background: rgba(255, 255, 255, .9);
  color: #344055;
  font-size: 12px;
  line-height: 34px;
}

.favorite-btn .van-icon {
  margin-right: 4px;
  font-size: 14px;
}

.favorite-btn.active {
  color: #ff8a1a;
}

.store-content {
  margin-top: -40px;
  padding: 0 14px 24px;
}

.goods-panel {
  min-height: calc(100vh - 92px);
  padding: 14px 8px 24px;
  border-radius: 7px 7px 0 0;
  background: #fff;
}

.goods-panel h1 {
  display: flex;
  align-items: center;
  margin: 0 0 13px;
  color: #06152b;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.goods-panel h1 .van-icon {
  margin-right: 7px;
  font-size: 14px;
}

.goods-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 14px;
  row-gap: 14px;
}

.goods-card {
  min-width: 0;
  overflow: hidden;
  border-radius: 7px;
  background: #f7f7f7;
}

.goods-image {
  height: 133px;
  overflow: hidden;
  border-radius: 7px;
  background: #e5e7ef;
}

.goods-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.goods-title {
  height: 36px;
  margin: 6px 0 0;
  overflow: hidden;
  padding: 0 1px;
  color: #06152b;
  font-size: 14px;
  line-height: 18px;
  word-break: break-word;
}

.goods-meta {
  display: flex;
  align-items: baseline;
  min-width: 0;
  padding: 0 1px 6px;
  line-height: 16px;
}

.goods-price {
  flex: 0 0 auto;
  margin-right: 4px;
  color: #ff0b0b;
  font-size: 14px;
  font-weight: 700;
}

.goods-sold {
  min-width: 0;
  overflow: hidden;
  color: #9aa0ad;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-state {
  padding: 80px 20px;
  color: #9aa0ad;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.kefu {
  position: fixed;
  right: 15px;
  bottom: 88px;
  z-index: 80;
  width: 62px;
  height: 62px;
}

.kefu_img {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 4px solid #fff;
  border-radius: 50%;
  background: linear-gradient(180deg, #1b7dff 0%, #0d80ff 64%, #fb1426 65%, #fb1426 100%);
  box-shadow: 0 6px 14px rgba(30, 70, 130, .25);
  color: #fff;
}

.kefu_img .van-icon {
  font-size: 31px;
}
</style>
